import React, { ChangeEvent, FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import styles from '../../militaryPreference.module.scss';
import { DisabilityFormVO, VeteranFormVO, MilitaryFormVO } from '@domain/vo/profile/ProfilePreferentialFormVO';

import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const PreferentialYnForm: FC = () => {
  const { control, reset, getValues } = useFormContext();

  const { field: militaryUseYnField } = useController({
    name: 'militaryUseYn',
    control,
  });

  const { field: disabilityUseYnField } = useController({
    name: 'disabilityUseYn',
    control,
  });

  const { field: veteranUseYnField } = useController({
    name: 'veteranUseYn',
    control,
  });

  const onChangeMilitaryUseYn = (e: ChangeEvent<HTMLInputElement>) => {
    militaryUseYnField.onChange(e.target.checked);

    if (!e.target.checked) {
      reset({
        ...getValues(),
        military: new MilitaryFormVO({
          status: null,
          type: null,
          militaryClass: null,
          dischargeType: null,
          startDate: '',
          endDate: '',
        }),
      });
    }
  };

  const onChangeDisabilityUseYn = (e: ChangeEvent<HTMLInputElement>) => {
    disabilityUseYnField.onChange(e.target.checked);

    if (!e.target.checked) {
      reset({
        ...getValues(),
        disability: new DisabilityFormVO({
          grade: null,
          type: null,
        }),
      });
    }
  };

  const onChangeVeteranUseYn = (e: ChangeEvent<HTMLInputElement>) => {
    veteranUseYnField.onChange(e.target.checked);

    if (!e.target.checked) {
      reset({
        ...getValues(),
        veteran: new VeteranFormVO({
          status: null,
          reason: null,
        }),
      });
    }
  };

  return (
    <div className={cx('checkboxArea')}>
      <label className={cx('label')}>
        <input
          type="checkbox"
          className={cx('input', 'hidden')}
          onChange={onChangeMilitaryUseYn}
          checked={militaryUseYnField.value ?? false}
        />
        <span className={cx('checkbox')} />
        병역
      </label>
      <label className={cx('label')}>
        <input
          type="checkbox"
          className={cx('input', 'hidden')}
          onChange={onChangeDisabilityUseYn}
          checked={disabilityUseYnField.value ?? false}
        />
        <span className={cx('checkbox')} />
        장애
      </label>
      <label className={cx('label')}>
        <input
          type="checkbox"
          className={cx('input', 'hidden')}
          onChange={onChangeVeteranUseYn}
          checked={veteranUseYnField.value ?? false}
        />
        <span className={cx('checkbox')} />
        보훈
      </label>
    </div>
  );
};

export default PreferentialYnForm;
